import React, { useEffect } from "react";
import { CoverageEligibility } from "types/CoverageEligibility";
import { trackPageViewUserStep } from "utils/analytics/trackEvent";
import ResultPageDeniedModel from "./components/DeniedComponent";
import ResultPageSuccessModel from "./components/SuccessComponent";
import Stepper from "uicomponents/Stepper";
import { getStepNumberFromURL } from "utils/helper";
import styles from "../../PreQualification.module.css";
import { STEPS } from "pages/PreQualification/utils/constants";
import { usePreQualContext } from "pages/PreQualification/PreQualification";
import Error from "uicomponents/Error";
interface IResultPageProps {
  data: CoverageEligibility;
}

const ResultPage = (props: IResultPageProps) => {
  const { data } = props;
  const { stepperNextStep, isEligibleForCoverage } = usePreQualContext();
  const isCoverageEligible =
    data?.healthInsuranceInformation?.isCoverageEligible;

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(3, "result page");
  }, []);

  if (isCoverageEligible === false) {
    isEligibleForCoverage && isEligibleForCoverage(true);
  }

  const applicationStep = data?.applications?.[0]?.step;
  const currentStep = getStepNumberFromURL();
  const isInValidStep = applicationStep && currentStep > applicationStep;

  if (isInValidStep) {
    return <Error />;
  }

  return (
    <div className={styles.prequalformContainer}>
      <Stepper
        steps={STEPS}
        currentStep={getStepNumberFromURL()}
        status={data?.applications?.[0].step || 3}
        onClick={(stepNumber) => stepperNextStep(stepNumber)}
        disabled={isCoverageEligible === false}
      />
      <div className={styles.prequalformDiv}>
        {isCoverageEligible ? (
          <ResultPageSuccessModel data={data} />
        ) : (
          <ResultPageDeniedModel />
        )}
      </div>
    </div>
  );
};

export default ResultPage;
